import React from 'react';
import { useHistory } from 'react-router-dom';
import PermissionForm from 'forms/PermissionForm';
import EditPermissionContext from 'contexts/EditPermissionContext';
import Permission from 'types/models/Permission';

export default (): JSX.Element => {
  const history = useHistory();
  const { selectedPermission } = React.useContext(EditPermissionContext);
  const [completePermission, setCompletePermission] = React.useState<Permission | null>(null);

  React.useEffect(() => {
    if (!selectedPermission) {
      history.push('/private/admin/permissions');
    } else {
      setCompletePermission(selectedPermission);
    }
  }, [selectedPermission]);

  if (!completePermission) return <></>;
  return <PermissionForm permission={completePermission} />;
};
